import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/components/layout/header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
